import { render } from "./Event-Details.vue?vue&type=template&id=9a82d914&scoped=true"
import script from "./Event-Details.vue?vue&type=script&lang=js"
export * from "./Event-Details.vue?vue&type=script&lang=js"

import "./Event-Details.vue?vue&type=style&index=0&id=9a82d914&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a82d914"

export default script